const jwt_customizer = {
    general: 'Si è verificato un errore durante la personalizzazione del token JWT. Si prega di riprovare più tardi.',
    can_not_create_for_admin_tenant: "Impossibile creare un personalizzatore di token JWT per l'amministratore del locatario.",
};
export default Object.freeze(jwt_customizer);
